import {createAction} from 'redux-act'

export interface TaskFormTypeValue {
  id: string;
  title: string;
}

export const setTaskModalVisible = createAction<boolean>('SET_TASK_MODAL_VISIBLE')
export const setTaskForm = createAction<any>('SET_TASK_FORM')
export const setTaskType = createAction<TaskFormTypeValue | null | undefined>('SET_TASK_TYPE');
